// @flow
import * as React from "react"
import { hot } from "react-hot-loader"
import { ImageFit } from "../../components/ImageFit"
import { Transition, animated } from "react-spring"
import {
  tRouteProps,
  tDefaultTemplate,
  tAudioDownload,
  tCartContext
} from "../../types"
import { Container } from "../../components/StyledComponents"
import { css } from "emotion/macro"
import { color } from "../../styles/variables"
import { CartContext } from "../../components/CartContext"
import { Link } from "react-static"
import { PageMarquee } from "../../components/PageMarquee"
import { PageMeta } from "../../components/PageMeta"

type tAudioDownloads = tDefaultTemplate & Array<tAudioDownload> & tCartContext

class AudioDownloads extends React.Component<
  tAudioDownloads & tRouteProps,
  {
    audio_downloads: Array<tAudioDownload>,
    userPrices: {}
  }
> {
  initialState = {
    audio_downloads: [],
    userPrices: {}
  }
  state = this.initialState
  componentDidMount = () => {
    this.setState({
      audio_downloads: this.props.audio_downloads.filter((item, i) => i < 10),
      userPrices: this.props.audio_downloads.reduce((acc, item) => {
        return {
          ...acc,
          [item.id]: "1.00"
        }
      }, {})
    })
  }
  showMoreItems = () => {
    this.setState((prevState) => ({
      audio_downloads: this.props.audio_downloads.filter(
        (item, i) => i < prevState.audio_downloads.length + 9
      )
    }))
  }
  userSetPrice = (id, price) => {
    const pattern = /^-?[0-9]\d*\.?\d*$/
    this.setState((prevState) => ({
      ...prevState,
      userPrices: {
        ...prevState.userPrices,
        [id]: price.match(pattern) ? price : prevState.userPrices[id]
      }
    }))
  }
  render() {
    const { props } = this
    return (
      <React.Fragment>
        {props.default_template_content && (
          <PageMarquee image={props.default_template_content.marquee_image} />
        )}
        <PageMeta title={props.title} description="" image={props.brand.logo} />
        <Container>
          <h1
            className={css`
              text-align: center;
              margin: 30px 0;
            `}
          >
            Audio Downloads
          </h1>

          <Transition
            keys={this.state.audio_downloads.map((item) => item.id)}
            from={{ opacity: 0, height: 0 }}
            enter={{ opacity: 1, height: 60 }}
            leave={{ opacity: 0, height: 0, pointerEvents: "none" }}
          >
            {this.state.audio_downloads.map((item) => (styles) => {
              const inCart = this.props.itemIsInCart("church-item" + item.id)

              return (
                <animated.div
                  style={styles}
                  className={css`
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 1px dashed rgba(195, 195, 195, 0.5);
                    padding-top: 2px;
                    padding-bottom: 2px;
                  `}
                >
                  <div
                    className={css`
                      display: flex;
                      align-items: center;
                    `}
                  >
                    {item.thumbnail && (
                      <ImageFit
                        src={item.thumbnail}
                        alt={item.title}
                        className={css`
                          width: 48px;
                          height: 48px;
                          margin-right: 20px;
                        `}
                      />
                    )}
                    <strong>
                      {item.title} | {item.date}
                    </strong>
                  </div>
                  <div
                    className={css`
                      display: flex;
                      align-items: center;
                    `}
                  >
                    <em
                      className={css`
                        font-size: 13px;
                        margin-right: 10px;
                      `}
                    >
                      set your price
                    </em>
                    <div
                      className={css`
                        display: flex;
                      `}
                    >
                      <input
                        className={css`
                          border: 1px solid #c3c3c3;
                          line-height: 48px;
                          font-size: 18px;
                          text-align: center;
                          width: 113px;
                          color: #232323;

                          &:disabled {
                            background: ${color.rgb.gray[2]};
                            opacity: 0.5;
                          }
                        `}
                        type="text"
                        pattern="^-?[0-9]\d*\.?\d*$"
                        disabled={inCart}
                        value={this.state.userPrices[item.id]}
                        onChange={(event) =>
                          this.userSetPrice(item.id, event.target.value)
                        }
                      />
                      <button
                        className={`btn 
                      ${inCart ? "btn-red" : "btn-orange"} ${css`
                          width: 125px;
                        `}`}
                        onClick={() => {
                          const cartItem = {
                            id: "church-item" + item.id,
                            price: this.state.userPrices[item.id],
                            details: item
                          }

                          inCart
                            ? props.removeFromCart(cartItem.id)
                            : props.addToCart(cartItem)
                        }}
                      >
                        {inCart ? "Remove" : "Purchase"}
                      </button>
                    </div>
                  </div>
                </animated.div>
              )
            })}
          </Transition>

          <div
            className={css`
              margin-top: 30px;
              text-align: center;
            `}
          >
            <button
              disabled={
                this.state.audio_downloads.length >=
                props.audio_downloads.length
              }
              className="btn btn-orange"
              onClick={this.showMoreItems}
            >
              Load More
            </button>
          </div>

          <div
            className={css`
              margin-top: 30px;
              text-align: center;
            `}
          >
            {Object.keys(props.cartItems).length > 0 && (
              <Link
                className={`btn btn-purple btn-checkout ${css`
                  width: calc(100% - 50px);
                  padding-top: 25px;
                  padding-bottom: 25px;
                `}`}
                to="/cart"
              >
                Checkout
              </Link>
            )}
          </div>
        </Container>
      </React.Fragment>
    )
  }
}

function RenderAudioDownloads(props: tAudioDownloads) {
  return (
    <CartContext>
      {(cartContext) => (
        // $FlowFixMe
        <AudioDownloads
          {...props}
          {...{
            cartItems: cartContext.items,
            addToCart: cartContext.addToCart,
            removeFromCart: cartContext.removeFromCart,
            itemIsInCart: cartContext.itemIsInCart
          }}
        />
      )}
    </CartContext>
  )
}

export default hot(module)(RenderAudioDownloads)



// WEBPACK FOOTER //
// /opt/build/repo/src/screens/Page/AudioDownloads.js